<template>
	<div class="quote-form text-left">
		<h5 class="sec-hd">
			If your size isn't listed, select 3 bedrooms.
		</h5>
		<h2 class="primary-hd">
			What <b>size</b> is your move?
		</h2>
		<div class="row move-size">
			<div
				v-for="(next_item, index) in sizes"
				:key="next_item.key"
				:class="{
					active: selectedSize && selectedSize.key == next_item.key
				}"
				class="col-md-6 size text-center"
				@click="setMoveSize(index)"
			>
				{{ next_item.key }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Size',
	data() {
		return {
			step: 2,
			sizes: [
				{ key: '1 bedroom', value: '1', type: 'apartment' },
				{ key: '2 bedrooms', value: '2', type: 'house' },
				{ key: '3 bedrooms', value: '3', type: 'house' },
				{ key: '4 bedrooms', value: '4', type: 'house' },
				{ key: '5+ bedrooms', value: '5', type: 'house' },
				{ key: 'Office', value: '5', type: 'office' },
			],
			selectedSize: {},
			selectedIndex: null,
		};
	},
	created() {
		this.checkForQuoteData();
	},
	mounted() {
		this.$store.dispatch('progress/updateProgress', this.step);

		window._vis_opt_queue = window._vis_opt_queue || [];
		window._vis_opt_queue.push(function() {
			window._vis_opt_goal_conversion(212);
		});

		document.onkeydown = event => {
			const evt = event || window.event;

			this.onKeyPress(evt);
		};
	},
	beforeDestroy() {
		document.onkeydown = null;
	},
	methods: {
		checkForQuoteData: function() {
			const quote = this.$store.state.quote;

			if (quote.moveSize.hasOwnProperty('key')) {
				this.selectedSize = {
					key: quote.moveSize.key,
					value: quote.moveSize.value,
					type: quote.moveSize.type,
				};

				this.selectedIndex = this.sizes.findIndex(size => {
					return this.selectedSize.key === size.key;
				});
			} else {
				this.selectedIndex = 0;
			}
		},
		setMoveSize: function(index) {
			this.selectedSize = this.sizes[index];
			this.selectedIndex = index;

			this.$store.dispatch('quote/update', { moveSize: this.selectedSize });

			this.$router.push({
				name: this.$store.getters['progress/getNextStep'].name,
			});
		},
		onKeyPress: function(event) {
			switch (event.keyCode) {
				case 37:
					// left
					if (this.selectedIndex > 0) {
						this.selectedIndex--;
						this.selectedSize = this.sizes[this.selectedIndex];
					}

					break;
				case 38:
					// up
					if (this.selectedIndex > 1) {
						this.selectedIndex -= 2;
						this.selectedSize = this.sizes[this.selectedIndex];
					}

					break;
				case 39:
					// right
					if (this.selectedIndex < (this.sizes.length - 1)) {
						this.selectedIndex++;
						this.selectedSize = this.sizes[this.selectedIndex];
					}

					break;
				case 40:
					// down
					if (this.selectedIndex < (this.sizes.length - 2)) {
						this.selectedIndex += 2;
						this.selectedSize = this.sizes[this.selectedIndex];
					}

					break;
				case 13:
					// enter
					this.setMoveSize(this.selectedIndex || 0);
					break;
			}
		},
	},
};
</script>

<style lang="scss">
.move-size.row {
    /*max-width: 475px;*/
    border-radius: 4px;
    font-size: 2rem;
    box-shadow: 0 2px 6px 0 rgba(74, 74, 74, 0.46);
    width: 90%;
    margin: 0;
}

.move-size.row .size {
    padding: 16px 12px;
    background: white;
    color: #4b475b;
    border-right: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    cursor: pointer;
    font-size: 1.4rem;
    display: inline-block;
}

.move-size.row .size:first-child {
    border-top-left-radius: 4px;
}

.move-size.row .size:nth-child(2) {
    border-top-right-radius: 4px;
}

.move-size.row .size:nth-last-child(2) {
    border-bottom-left-radius: 4px;
}

.move-size.row .size:last-child {
    border-bottom-right-radius: 4px;
}

.move-size.row .size:hover,
.move-size.row .size.active {
    background: #df5435;
    color: white;
}

@media (max-width: 768px) {
    .move-size.row .size {
        border-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: 0;
    }

    .move-size.row .size:first-child {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }

    .move-size.row .size:last-child {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }
}
</style>
